import React, { useRef } from 'react'
import { cn } from '@amusnet/react-ui'
import { usePulseAnimation } from '@hooks'
import startButtonSvg from '@assets/ultra-play/ultra-play-start-button.svg'
import pauseButtonSvg from '@assets/ultra-play/ultra-play-pause-button.svg'

// Shared start/pause artwork button. `size` is the square px size of the icon.
const UltraPlayPlayPauseButton: React.FC<{
    isPlaying: boolean
    onClick: () => void
    size: number
    disabled?: boolean
    className?: string
    pulse?: boolean
}> = ({ isPlaying, onClick, size, disabled, className, pulse }) => {
    const buttonRef = useRef<HTMLButtonElement>(null)

    usePulseAnimation({
        ref: buttonRef,
        pulse,
        peakStyles: { boxShadow: '0px 0px 24.7px 0px #FFF08999' },
        // Same glow color at zero alpha/blur/spread, so it eases in/out smoothly instead of jumping in
        // from (or snapping back to) no shadow at all.
        restStyles: { boxShadow: '0px 0px 0px 0px #FFF08900' },
    })

    return (
        <button
            id="ultra-play-play-pause-button"
            ref={buttonRef}
            onClick={onClick}
            disabled={disabled}
            className={cn(
                'flex items-center justify-center rounded-full',
                //  a dimmed button must never be clickable.
                disabled && 'pointer-events-none',
                className
            )}
        >
            <img
                src={isPlaying ? pauseButtonSvg : startButtonSvg}
                width={size}
                height={size}
                alt={isPlaying ? 'Pause' : 'Play'}
            />
        </button>
    )
}

export default UltraPlayPlayPauseButton
